/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AvailableRequestBuilderRequestsMetadata, type AvailableRequestBuilder } from './available/index.js';
// @ts-ignore
import { IntegrationItemRequestBuilderNavigationMetadata, type IntegrationItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { TemplatesRequestBuilderNavigationMetadata, type TemplatesRequestBuilder } from './templates/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/integrations
 */
export interface IntegrationsRequestBuilder extends BaseRequestBuilder<IntegrationsRequestBuilder> {
    /**
     * The available property
     */
    get available(): AvailableRequestBuilder;
    /**
     * The templates property
     */
    get templates(): TemplatesRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.integrations.item collection
     * @param integrationId Route parameter: the integration to disconnect.
     * @returns {IntegrationItemRequestBuilder}
     */
     byIntegrationId(integrationId: string) : IntegrationItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const IntegrationsRequestBuilderUriTemplate = "{+baseurl}/api/integrations";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const IntegrationsRequestBuilderNavigationMetadata: Record<Exclude<keyof IntegrationsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byIntegrationId: {
        navigationMetadata: IntegrationItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["integration%2Did"],
    },
    available: {
        requestsMetadata: AvailableRequestBuilderRequestsMetadata,
    },
    templates: {
        navigationMetadata: TemplatesRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
